<template>
  <div v-if="campaign">
    <div v-if="!campaign.header_content" class="header" :class="{'sticky-header': isCustomerPortal}">
      <div class="desktop-header d-none d-sm-flex border">
        <div class="header-section left">
          <div v-if="isMainMenu">
            <Language></Language>
          </div>
          <div v-else-if="isSessionActiveAndReady" class="home-button">
            <b-link @click="goHome()" class="footer_btn_color">
              <font-awesome-icon :icon="['fas', 'home']" class="footer_btn"></font-awesome-icon>
              <span>MAIN MENU</span>
            </b-link>
          </div>
        </div>
        <div class="header-section center">
          <div class="logo logo-bg logo-con">
            <b-link v-if="campaign.logo" @click="goHome()"><img width="" height="" id="desktop-logo" :alt="campaign.name" :src="getLogo" /></b-link>
          </div>
        </div>
        <div class="header-section right">
          <div class="ml-auto logout-button">
            <div class="dropdown header-right-content" v-if="showCart">
              <b-link @click="setCartState(!cartIsOpen)" class="footer_btn_color cart-icon">
                <font-awesome-icon :icon="['fas', 'shopping-cart']" class="footer_btn"></font-awesome-icon>
                <span class="notranslate cart-counter">{{totalCartQuantity}}</span>
              </b-link>
              <div class="position-absolute">
                <div v-if="cartIsOpen" class="caret-up"></div>
                <div id="cart-dropdown-desk" :class="{'d-block': cartIsOpen }" class="dropdown-content cart-dropdown">
                  <Cart @close="setCartState(false)"></Cart>
                </div>
              </div>
            </div>
            <div class="dropdown header-right-content" v-if="isSessionUserKnown">
              <b-link class="footer_btn_color">
                <font-awesome-icon :icon="['far', 'user']" class="footer_btn"></font-awesome-icon>
                <span class="notranslate">{{session.customer.first_name}}</span>
              </b-link>
              <div class="dropdown-content">
                <router-link to="/logout" class="footer_btn_color">
                  <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="footer_btn"></font-awesome-icon>
                  <span>Logout</span>
                </router-link>
              </div>
            </div>
            <div v-else-if="canLogoutSession" class="header-right-content">
              <router-link to="/logout" class="footer_btn_color">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="footer_btn"></font-awesome-icon>
                <span>LOG OUT</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-header d-sm-none border">
        <div v-if="isMainMenu">
          <Language></Language>
        </div>
        <div v-if="campaign.logo" class="logo">
          <b-link @click="goHome()"><img width="" height="" id="mobile-logo" :alt="campaign.name" :src="getMobileLogo" /></b-link>
        </div>
        <div class="ml-auto logout-button">
          <div class="dropdown header-right-content" v-if="showCart">
            <b-link @click="setCartState(!cartIsOpen)" class="footer_btn_color">
              <font-awesome-icon :icon="['fas', 'shopping-cart']" class="footer_btn"></font-awesome-icon>
              <span class="notranslate cart-counter">{{totalCartQuantity}}</span>
            </b-link>
          </div>
         </div>
      </div>
      <transition name="slide-fade">
        <div v-if="cartIsOpen" class="d-sm-none cart-align-sm border">
          <Cart @close="setCartState(false)"></Cart>
        </div>
      </transition>
    </div>
    <div v-else>
      <div v-html="campaign.header_content"></div>
      <Language></Language>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {CustomerPortalInputType} from '@/constants'
import {selectLanguage} from '@/utils'
import Language from './Language'
const Cart = () => import('./Cart')

export default {
  name: 'Header',
  components: {Language, Cart},
  computed: {
    ...mapState(['campaign', 'session', 'currentLanguage', 'cart', 'cartIsOpen']),
    ...mapGetters(['canLogoutSession', 'isSessionUserKnown', 'isSessionActiveAndReady', 'isMainMenu',
      'checkoutDisabled']),
    getLogo: function() {
      if (this.campaign && this.campaign['logo']) {
        return this.campaign['logo']['file']
      }
      return null
    },
    getMobileLogo: function() {
      if (this.campaign && this.campaign['mobile_logo']) {
        return this.campaign['mobile_logo']['file']
      }
      return this.getLogo
    },
    showCart: function() {
      return this.cart && this.cart.length && !this.checkoutDisabled
    },
    totalCartQuantity: function() {
      if (this.showCart) {
        return this.cart.reduce((quantity, item) => {
          quantity += item.quantity
          return quantity
        }, 0)
      }
      return 0
    },
    isCustomerPortal: function() {
      return this.session && Object.values(CustomerPortalInputType).indexOf(this.session['step_type']) > -1
    }
  },
  watch: {
    '$store.state.campaign': function(to) {
      if (to && to['header_content']) {
        setTimeout(() => this.renderHeaderContent(), 1000)
      }
    },
    isSessionUserKnown: function(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateSessionAuthenticatedUser(newVal)
      }
    },
    canLogoutSession: function(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateSessionActiveUser(null, newVal)
      }
    },
    '$store.state.cartIsOpen': function() {
      if (window.innerWidth <= 576) {
        if (this.cartIsOpen) {
          document.documentElement.style.overflow = 'hidden'
        } else {
          document.documentElement.style.overflow = 'auto'
        }
      }
    }
  },
  methods: {
    goHome: function() {
      if (this.isSessionActiveAndReady) {
        this.$store.commit('busy')
        this.$store.dispatch('home')
          .then(session => {
            if (this.$router.history.current.meta.requireRedirectForHome) {
              this.$router.replace({name: 'session'}) // If on faq details move to main page
            } else {
              this.$router.go(0) // refresh
            }
          })
      }
    },
    setSelectedLanguageInfo: function(element, languageOption, currentLanguage) {
      const checkIcon = '<svg data-v-a9bd70f0="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="selected-language-icon lang-check svg-inline--fa fa-check fa-w-16"><path data-v-a9bd70f0="" fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" class=""></path></svg>'
      const isSelectedLanguage = languageOption.getAttribute('value') === currentLanguage
      if (isSelectedLanguage) {
        if (element.querySelector('.selected-language-icon')) element.querySelector('.selected-language-icon').remove()
        const selectLanguageFlag = languageOption.querySelector('img').getAttribute('src')
        if (selectLanguageFlag) {
          element.querySelector('[identifier="selected-language"]').querySelector('img').setAttribute('src', selectLanguageFlag)
        }
        languageOption.innerHTML += checkIcon
      }
    },
    handleBuilderComponent: function() {
      const _this = this
      // setup language component
      const languageElements = Array.from(document.querySelectorAll("[elemtype='select-language']")) || []
      languageElements.forEach(element => {
        const languageOptions = Array.from(element.querySelectorAll("[elemtype='dropdown-option']")) || []
        languageOptions.forEach(languageOption => {
          _this.setSelectedLanguageInfo(element, languageOption, _this.currentLanguage)
          if (!languageOption.callback) {
            languageOption.addEventListener('click', languageOption.callback = function callback(e) {
              e.preventDefault()
              e.stopPropagation()
              let value = e.target.getAttribute('value')
              const closestEl = e.target.closest("[elemtype='dropdown-option']")
              if (!value) {
                value = closestEl && closestEl.getAttribute('value')
              }
              _this.setSelectedLanguageInfo(element, closestEl, value)
              selectLanguage(value)
              return false
            })
          }
        })

        element.addEventListener('click', function(e) {
          if (window.innerWidth <= 575) {
            _this.$bvModal.show('mob-lang-modal')
          }
        })
      })
    },
    updateSessionAuthenticatedUser: function(show = false) {
      const _this = this
      const userDropdownElements = Array.from(document.querySelectorAll('[elemtype="user-dropdown"]')) || []
      userDropdownElements.forEach((element) => {
        if (_this.session && _this.session.customer) {
          let usernameEl = element.querySelector('.gjs-username') || element.querySelector('.username')
          if (usernameEl) {
            usernameEl.textContent = _this.session.customer.first_name
          }
        }
        if (show) {
          element.style = 'display: inline-flex !important'
        } else {
          element.style = 'display: none !important'
        }

        _this.updateSessionActiveUser(element, show)
      })
    },
    updateSessionActiveUser: function(element, show = false) {
      element = element || document
      const logoutBtns = Array.from(element.querySelectorAll('[elemtype="logout"]')) || []
      logoutBtns.forEach((element) => {
        if (show) {
          element.style = 'display: flex !important'
        } else {
          element.style = 'display: none !important'
        }
      })
    },
    renderHeaderContent: function() {
      if (this.campaign && this.campaign.header_content) {
        this.updateSessionActiveUser(null, false)
        this.updateSessionAuthenticatedUser(false)
        // get the current language translation
        const lang = this.$cookie.get('googtrans')

        if (lang && lang.length) {
          if (lang[0] === '/') {
            const languages = lang.slice(1).split('/')

            if (languages.length === 2) {
              this.$store.commit('set_language', languages[1])
            }
          }
        }
        this.handleBuilderComponent()
        if (this.isSessionUserKnown) {
          this.updateSessionAuthenticatedUser(true)
        } else if (this.canLogoutSession) {
          this.updateSessionActiveUser(null, true)
        }
      }
    },
    setCartState: function(value) {
      this.$store.commit('set_cart_state', value)
    }
  },
  beforeMount() {
    this.setCartState(false)
  },
  mounted() {
    const _this = this
    setTimeout(() => _this.renderHeaderContent(), 1000)
    window.addEventListener('click', toggleCartDropdown)

    function toggleCartDropdown(event) {
      if (window.innerWidth > 575) {
        const dropdown = document.getElementById('cart-dropdown-desk')
        const cartClick = event.target.closest('.cart-icon')
        const isCartDropdown = event.target.closest('#cart-dropdown-desk')

        if (!cartClick && !isCartDropdown && dropdown && event.target.id !== dropdown.id) {
          if (dropdown.classList.contains('d-block') && _this.cartIsOpen) {
            _this.setCartState(false)
          }
        }
      }
      event.stopPropagation()
    }
  }
}
</script>

<style scoped lang="less">
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
     transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .logout-button {

    .header-right-content {
      display: inline-block;
      margin-left: 25px;
    }

    .dropdown-content {
      right: 0;
    }

    .cart-dropdown {
      padding: 20px !important;
      min-width: 412px;
      max-width: 100%;
    }

    .cart-counter {
      position: absolute;
      top: -5px;
      left: 25px;
      color: var(--theme_color);
      font-size: 12px;
    }

    .cart-btn-wrapper {
      .cart-btn {
        font-weight: 500 !important;
      }
    }
  }

  @media only screen and (min-width: 813px) {
    .home-button {
      left: 100px;
    }

    .logout-button {
      right: 100px;
    }
  }

</style>
